module.exports = __webpack_public_path__ + "static/media/linkedin.863ea3db.jpg";